import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { HorseGroup } from './horse-group';
export { HorseGroup };
import { horseGroupSchema } from '@schemas/business-objects/horse-group';
import { GroupMatchFormArray } from './group-match-form-group';
import { HorseGroupMemberFormArray } from './horse-group-member-form-group';

export class HorseGroupFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    category: SchemaFormControl;
    subCategory: SchemaFormControl;
    legacyId: SchemaFormControl;
    members: HorseGroupMemberFormArray;
    groupMatches: GroupMatchFormArray;
  };

  declare value: Partial<HorseGroup>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(horseGroupSchema, HorseGroup, data, options);
  }

  get object(): HorseGroup {
    return new HorseGroup(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'members':
        return new HorseGroupMemberFormArray();
      case 'groupMatches':
        return new GroupMatchFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<HorseGroup[]> {
    return HorseGroup.find(filter);
  }

  static async findOne(filter?: any): Promise<HorseGroup | null> {
    return HorseGroup.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<HorseGroup> {
    return HorseGroup.findById(id, filter);
  }

  static async create(data: Partial<HorseGroup>): Promise<HorseGroup> {
    return HorseGroup.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<HorseGroup>,
  ): Promise<HorseGroup> {
    return HorseGroup.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return HorseGroup.deleteById(id);
  }
}

export class HorseGroupFormArray extends PersistedFormArray {
  declare controls: HorseGroupFormGroup[];

  readonly entityName = 'HorseGroup' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(horseGroupSchema, HorseGroup, options);
  }

  protected override createItemGroup() {
    return new HorseGroupFormGroup();
  }

  get array(): HorseGroup[] {
    return this.controls.map((group: HorseGroupFormGroup) => group.object);
  }
}

export class HorseGroupPersistedArray extends PersistedArray<HorseGroup> {
  readonly entityName = 'HorseGroup' as const;

  constructor(options?: PersistedArrayOptions) {
    super(HorseGroup, options);
  }
}
